export default __webpack_public_path__ + "static/media/1.7a7e1517.mp4";